import * as ActionTypes from '../constants/actionTypes';

export const initialState = {
    request: false,
    error: '',
    data: [],
};

export default function (state = initialState, action) {

    switch (action.type) {
        case ActionTypes.ALL_MODELS_REQUEST:
            return {
                ...state,
                request: true,
                error: '',
            };

        case ActionTypes.ALL_MODELS_SUCCESS:
            return {
                ...state,
                request: false,
                error: '',
                data: action.payload
            };

        case ActionTypes.ALL_MODELS_ERROR:
            return {
                ...state,
                request: false,
                error: action.payload
            };

        default :
            return state;
    }

}